export default {
  barinka: {
    fullName: 'Lukáš Bařinka',
    picture: require('../resources/presenters/barinka.png'),
  },
  pavlik: {
    fullName: 'Vojtěch Pavlík',
    picture: require('../resources/presenters/pavlik.jpg'),
  },
  koci: {
    fullName: 'Karel Kočí',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  miler: {
    fullName: 'Emil Miler',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  holecek: {
    fullName: 'Ondřej Holeček',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  franc: {
    fullName: 'Miroslav Franc',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  zandl: {
    fullName: 'Patrick Zandl',
    picture: require('../resources/presenters/zandl.jpg'),
  },
  cejka: {
    fullName: 'Tomáš Čejka',
    picture: require('../resources/presenters/cejka.jpg'),
  },
  hala: {
    fullName: 'Tomáš Hála',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  stehlik: {
    fullName: 'Petr Stehlík',
    picture: require('../resources/presenters/stehlik.png'),
  },
  hodac: {
    fullName: 'Petr Hodač',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  pulec: {
    fullName: 'Pavel Pulec',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  vondra: {
    fullName: 'Tomáš Vondra',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  ansorgova: {
    fullName: 'Zuzana Lena Ansorgová',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  polasek: {
    fullName: 'Petr Polášek',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  sika: {
    fullName: 'Ondřej Sika',
    picture: require('../resources/presenters/sika.jpg'),
  },
  caletka: {
    fullName: 'Ondřej Caletka',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  benes: {
    fullName: 'Milan Beneš',
    picture: require('../resources/presenters/benes.jpg'),
  },
  krcmar: {
    fullName: 'Petr Krčmář',
    picture: require('../resources/presenters/krcmar.jpg'),
  },
  becvarik: {
    fullName: 'David Bečvařík',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  baler: {
    fullName: 'Jan Baler',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  sojka: {
    fullName: 'Michal Sojka',
    picture: require('../resources/presenters/sojka.jpg'),
  },
  snajdr: {
    fullName: 'Pevel Šnajdr',
    picture: require('../resources/presenters/snajdr.jpg'),
  },
  kaplan: {
    fullName: 'Věroš Kaplan',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  ziegler: {
    fullName: 'Karel Ziegler',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  bedrich: {
    fullName: 'Tomáš Bedřich',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  vician: {
    fullName: 'Martin Vicián',
    picture: require('../resources/presenters/vician.jpg'),
  },
  veverka: {
    fullName: 'Jakub Veverka',
    picture: require('../resources/presenters/veverka.png'),
  },
  hroncok: {
    fullName: 'Miro Hrončok',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  novy_stec: {
    fullName: 'Zdeněk Nový, Petr Štéc',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  uhlik: {
    fullName: 'Jan Uhlík',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  jilek: {
    fullName: 'Karel Jílek',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  pluskal: {
    fullName: 'Martin Pluskal',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  puzman: {
    fullName: 'Václav Pužman',
    picture: require('../resources/presenters/generic-presentation.png'),
  },
  iliushin: {
    fullName: 'Vladislav Iliushin',
    picture: require('../resources/presenters/iliushin.jpg'),
  },
  zapletal: {
    fullName: 'Lukáš Zapletal',
    picture: require('../resources/presenters/zapletal.jpg'),
  },
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presenters.js